import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import { getSelectedSubjectStats, getSelectedSubjectTimeSpent, getSortedSchedule } from '../utils';
import { type StudentScheduleSlot, type SubjectMetrics } from '../../model';
import { SlotItem } from './SlotItem';

const BackContainer = styled.div`
  position: absolute;
  height: 900px;
  width: 900px;
  background-color: #c6cad3;
  border-radius: 50%;
  box-shadow:
    12px 24px 33px 0px rgba(91, 99, 120, 0.1) inset,
    7px 5px 12px 0px rgba(91, 99, 120, 0.32) inset;
`;

const TopContainer = styled.div`
  position: absolute;
  height: 670px;
  width: 670px;
  background-color: #c6cad3;
  box-shadow: inset -3.5px 1px 19px 5.5px #e3e3e3;
  border-radius: 50%;
`;

const SlotContainer = styled.div`
  height: 880px;
  width: 880px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
`;

type Props = {
  currentTime: Date;
  scheduleData: StudentScheduleSlot[];
  onSlotSelected: (data: StudentScheduleSlot) => void;
  subjectStatsMap: Record<string, SubjectMetrics>;
  subjectTimeSpentMap: Record<string, [number, number]>;
};

export const SlotsRing = ({
  currentTime,
  scheduleData,
  subjectStatsMap,
  subjectTimeSpentMap,
  onSlotSelected,
}: Props) => {
  const [slotsData, setSlotsData] = useState(() => getSortedSchedule(scheduleData));

  useEffect(() => {
    const newData = getSortedSchedule(scheduleData);
    setSlotsData(newData);
  }, [currentTime]);

  const renderSlots = () =>
    slotsData.map((item, i) => {
      const eachAngle = 180 / slotsData.length;
      const angle = -180 + eachAngle + i * eachAngle;
      const skew = 90 - eachAngle;

      return (
        <SlotItem
          key={i}
          angle={angle}
          skew={skew}
          data={item}
          currentTime={currentTime}
          index={i}
          onClick={onSlotSelected}
          stats={getSelectedSubjectStats(subjectStatsMap, item)}
          timeSpentStats={getSelectedSubjectTimeSpent(subjectTimeSpentMap, item)}
        />
      );
    });

  return (
    <>
      <BackContainer />
      <SlotContainer>{renderSlots()}</SlotContainer>
      <TopContainer />
    </>
  );
};
